import styled from "styled-components";
import { StyledGlobalMainContainer } from "../globalStyle";

export const StyledContainer = styled(StyledGlobalMainContainer)`
  margin-top: 47px;
  @media (max-width: 768px) {
    padding: 0 22px 22px;
    margin-top: 99px;
  }
  @media (max-width: 425px) {
    padding: 0 22px 22px;
    margin-top: 76px;
  }
`;

export const StyledTitleContainer = styled.div`
  display: grid;
  justify-items: center;
  grid-row-gap: 14px;
  h1 {
    text-align: start;
  }
`;

export const StyledDescription = styled.div`
  display: grid;
  justify-items: center;
  align-items: center;
`;

export const StyledMainContainer = styled.div`
  display: grid;
  grid-template-columns: 1.3fr 2fr;
  grid-column-gap: 85px;
  grid-row-gap: 16px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
  }
  @media (max-width: 768px) {
  }
`;

export const StyledLeftContainer = styled.div`
  display: grid;
  grid-row-gap: 14px;
  grid-auto-rows: max-content;
  h1 {
    text-align: start;
  }
`;

export const StyledRightContainer = styled.div`
  /* display: grid;
  grid-row-gap: 16px;
  grid-auto-rows: max-content; */
  @media (max-width: 576px) {
    display: none;
  }
`;

export const StyledImageContainerCode = styled.div`
  position: relative;
  background-color: #264445;
  font-family: monospace;
  max-width: 620px;
  width: 100%;
  height: 641px;
  text-align: start;
  border-radius: 10px;
  padding: 42px 76px;
  box-sizing: border-box;
  margin: 0 auto;
  p,
  span {
    line-height: 24px;
    font-size: 16px;
  }
  @media (max-width: 1200px) {
    right: unset;
  }
  @media (max-width: 768px) {
    right: 0;
  }
`;

export const StyledCircleContainer = styled.div`
  display: grid;
  grid-column-gap: 5px;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: center;
  margin-bottom: 30px;
`;

export const StyledCircle = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: ${(p) => p.bgColor};
`;

export const StyledIconContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 26px;
  grid-auto-columns: max-content;
  align-items: center;
  margin-top: 40px;
  @media (max-width: 576px) {
    display: none;
  }
`;

export const StyledButtonContainer = styled.div`
  width: 203px;
  height: 55px;
  margin-top: 48px;
  justify-self: start;
`;

export const StyledResponsiveContainer = styled.div`
  grid-auto-flow: column;
  grid-column-gap: 26px;
  grid-auto-columns: max-content;
  align-items: center;
  margin-top: 40px;
  display: none;
  @media (max-width: 576px) {
    display: grid;
  }
`;
